import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Search, Lock, User, Phone, CreditCard, Download, Check, Loader2, AlertCircle, ArrowLeft, Home, List, LogOut, Key } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Dialog } from '@headlessui/react';
import jsPDF from 'jspdf';
import config from '../config/config';

const ParentFeePayment = () => {
  const [currentStep, setCurrentStep] = useState('login');
  const [isLoading, setIsLoading] = useState(false);
  const [admissionNumber, setAdmissionNumber] = useState('');
  const [invoiceId, setInvoiceId] = useState('');
  const [transactionIdd, setTransactionId] = useState('');
  const [enteredAmounts, setEnteredAmounts] = useState({});
  const [total__amount,setTotalAmount2]=useState(0);
  const [formData, setFormData] = useState({
    parentPhone: '',
    parentName: '',
    admissionNumber: '',
    phoneNumber: '',
    amount: '',
    studentName: '',
    studentClass: '',
    feeBalance: 0,
    term: '',
    invoiceDetails: {},
    transactionId: '',
  });
  const [errors, setErrors] = useState({});
  const [stkPushSent, setStkPushSent] = useState(false);
  const [paymentComplete, setPaymentComplete] = useState(false);
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [students, setStudents] = useState([]);
  const [payments, setPayments] = useState([]);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [passwordError, setPasswordError] = useState('');

  const setTotalAmount = () => {
     const total = Object.values(enteredAmounts).reduce(
          (sum, value) => sum + (parseFloat(value) || 0),
          0
        );
        setTotalAmount2(total);
  }

  // Function to fetch CSRF cookie and token
  const getCsrfToken = async () => {
    try {
      await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, { withCredentials: true });
      const match = document.cookie.match(new RegExp('(^| )XSRF-TOKEN=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : null;
    } catch (error) {
      console.error('Failed to fetch CSRF token:', error);
      return null;
    }
  };

  // Axios instance with interceptors for CSRF token
  const api = axios.create({
    baseURL: config.API_URL,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    withCredentials: true,
  });

  // Add interceptor to include CSRF token and Authorization header
  api.interceptors.request.use(async (config) => {
    const xsrfToken = await getCsrfToken();
    if (xsrfToken) {
      config.headers['X-XSRF-TOKEN'] = xsrfToken;
    }
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  }, (error) => Promise.reject(error));

  // Handle 419 errors by refreshing CSRF token
  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 419) {
        const xsrfToken = await getCsrfToken();
        if (xsrfToken) {
          error.config.headers['X-XSRF-TOKEN'] = xsrfToken;
          return api.request(error.config); // Retry the request
        }
      }
      return Promise.reject(error);
    }
  );

  // Phone validation
  const validatePhone = (phone) => {
    const phoneRegex = /^254[0-9]{9}$/;
    return phoneRegex.test(phone.replace(/\s/g, ''));
  };

  const formatPhone = (phone) => {
    const cleaned = phone.replace(/\D/g, '');
   // if (cleaned.startsWith('0')) return '254' + cleaned.substring(1);
    //if (cleaned.startsWith('254')) return cleaned;
    //if (cleaned.length === 9) return '254' + cleaned;
    return cleaned;
  };



 // Handle login
  const handleOtp = async () => {
    setErrors({});
    if (!formData.parentPhone) {
      setErrors({ login: 'Please fill in all fields' });
      return;
    }else if (!/^\d{10}$/.test(formData.parentPhone)) {
      setErrors({ login: 'Phone number must be exactly 10 digits and must follow the format 0712345678' });
  
     return;
  }

    const formattedPhone = formatPhone(formData.parentPhone);
    setIsLoading(true);
    try {


      await new Promise(resolve => setTimeout(resolve, 1500));
            await axios.get(config.API_URL + "/sanctum/csrf-cookie", {
                withCredentials: true,
            });

            const getCookie = (name) => {
                const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
                if (match) return decodeURIComponent(match[2]);
                return null;
            };
            const xsrfToken = getCookie("XSRF-TOKEN");

            const response = await api.post(
                config.API_URL + "/api/send_otp",
                {
        phone: formattedPhone,
        password: formData.parentName,
      },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        "X-XSRF-TOKEN": xsrfToken,
                    },
                    withCredentials: true,
                }
            );


     if(response.data.status!=1){
      alert('Sorry, something went wrong');
     }else{
      alert('Enter the OTP sent to your phone');
     }

     
    } catch (error) {
      setErrors({ login: error.response?.data?.error || 'Login failed' });
    } finally {
      setIsLoading(false);
    }
  };

  // Handle login
  const handleLogin = async () => {
    setErrors({});
    if (!formData.parentPhone || !formData.parentName) {
      setErrors({ login: 'Please fill in all fields' });
      return;
    }else if (!/^\d{10}$/.test(formData.parentPhone)) {
      setErrors({ login: 'Phone number must be exactly 10 digits and must follow the format 0712345678' });
  
     return;
  }

    const formattedPhone = formatPhone(formData.parentPhone);
    setIsLoading(true);
    try {


      await new Promise(resolve => setTimeout(resolve, 1500));
            await axios.get(config.API_URL + "/sanctum/csrf-cookie", {
                withCredentials: true,
            });

            const getCookie = (name) => {
                const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
                if (match) return decodeURIComponent(match[2]);
                return null;
            };
            const xsrfToken = getCookie("XSRF-TOKEN");

            const response = await api.post(
                config.API_URL + "/api/parent_login",
                {
        phone: formattedPhone,
        password: formData.parentName,
      },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        "X-XSRF-TOKEN": xsrfToken,
                    },
                    withCredentials: true,
                }
            );


     

      setToken(response.data.token);
      localStorage.setItem('token', response.data.token);
      setFormData((prev) => ({
        ...prev,
        parentPhone: formattedPhone,
        parentName: `${response.data.student?.parent_firstname} ${response.data.student?.parent_lastname}`,
      }));
      fetchStudents();
      setCurrentStep('home');
    } catch (error) {
      setErrors({ login: error.response?.data?.error || 'Login failed' });
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch students
  const fetchStudents = async () => {
    setIsLoading(true);
    try {
       await axios.get(config.API_URL + "/sanctum/csrf-cookie", {
                withCredentials: true,
            });

            const getCookie = (name) => {
                const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
                if (match) return decodeURIComponent(match[2]);
                return null;
            };
            const xsrfToken = getCookie("XSRF-TOKEN");

      const response = await api.get(config.API_URL + "/api/pull__students/parent/"+formData.parentPhone,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        "X-XSRF-TOKEN": xsrfToken,
                    },
                    withCredentials: true,
                }
            );
      setStudents(response.data.data || []);
    } catch (error) {
      setErrors({ students: error.response?.data?.error || 'Failed to fetch students' });
    } finally {
      setIsLoading(false);
    }
  };

  // Handle student search
  const handleStudentSearch = async (admNumber) => {
    setErrors({});
    setEnteredAmounts({});
    const admission = admNumber || formData.admissionNumber;
    setAdmissionNumber(admission);

    if (!admission) {
      setErrors({ search: 'Please enter admission number' });
      return;
    }

    setIsLoading(true);
    try {
      const response = await api.post('/api/student_search', {
        admission_number: admission.toUpperCase(),
        phone: formData.parentPhone,
      });

      if (response.data.status === 1) {
        const { student } = response.data.student;
        setAdmissionNumber(response.data.admission_number);
        setFormData((prev) => ({
          ...prev,
          studentName: student?.name,
          studentClass: student?.class,
          feeBalance: student?.fee_balance,
          admissionNumber: student?.admission_number,
        }));
        setCurrentStep('invoice');
      } else {
        setErrors({ search: 'Cannot find such a student' });
      }
    } catch (error) {
      setErrors({ search: error.response?.data?.error || 'Student not found' });
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch payment history
  const fetchPayments = async () => {
    setIsLoading(true);
    try {
      const response = await api.get('/api/payment_history/'+formData.parentPhone);
      setPayments(response.data.payments || []);
       setStudents(response.data.data || []);
    } catch (error) {
      setErrors({ payments: error.response?.data?.error || 'Failed to fetch payment history' });
    } finally {
      setIsLoading(false);
    }
  };

  // Handle payment
  const handlePayment = async () => {
    setErrors({});
    setTotalAmount();
    const formattedPhone = formatPhone(formData.phoneNumber);
    const amount = parseFloat(formData.amount);

    setIsLoading(true);
    setStkPushSent(true);
    setCurrentStep('stk-push');
    try {
      const response = await api.post('/api/post-payment', {
        admission_number: formData.admissionNumber,
        phone_number: formattedPhone,
        invoiceId,
        amount,
        enteredAmounts,
      });

      setTransactionId(response.data.transaction_id);
      setFormData((prev) => ({
        ...prev,
        phoneNumber: formattedPhone,
        transactionId: response.data.transaction_id,
      }));
    } catch (error) {
      setErrors({ payment: error.response?.data?.error || 'Payment processing failed' });
      setStkPushSent(false);
      setCurrentStep('payment');
    } finally {
      setIsLoading(false);
    }
  };

  // Poll payment status
  const pollPayment = async () => {
    if (!transactionIdd) return;
    const intervalId = setInterval(async () => {
      try {
        const response = await api.get(`/api/pollPayment/${transactionIdd}`);
        if (response.data.status === 1) {
          setEnteredAmounts({});
          setPaymentComplete(true);
          setCurrentStep('receipt');
          clearInterval(intervalId);
        }
      } catch (error) {
        setErrors({ payment: error.response?.data?.error || 'Payment verification failed' });
        clearInterval(intervalId);
      }
    }, 2000);
  };

  // Download receipt as PDF
  const downloadReceipt = async (transactionId) => {
    try {
      window.open(`${config.API_URL}/downloadReceipt/${transactionId}/${token}`);
      //const response = await api.get(`/api/pull-payment-receipt/${transactionId}`);
      
    } catch (error) {
      setErrors({ receipt: error.response?.data?.error || 'Failed to download receipt' });
    }
  };

  // Handle password change
  const handlePasswordChange = async () => {
    setPasswordError('');
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setPasswordError('New password and confirmation do not match');
      return;
    }

    setIsLoading(true);
    try {
      await api.post('/api/change_password', {
        old_password: passwordData.oldPassword,
        new_password: passwordData.newPassword,
      });
      setIsPasswordModalOpen(false);
      setPasswordData({ oldPassword: '', newPassword: '', confirmPassword: '' });
    } catch (error) {
      setPasswordError(error.response?.data?.error || 'Password change failed');
    } finally {
      setIsLoading(false);
    }
  };

  // Sign out
  const handleSignOut = () => {
    localStorage.removeItem('token');
    setToken('');
    resetForm();
  };

  // Reset form
  const resetForm = () => {
    setCurrentStep('login');
    setFormData({
      parentPhone: '',
      parentName: '',
      admissionNumber: '',
      phoneNumber: '',
      amount: '',
      studentName: '',
      studentClass: '',
      feeBalance: 0,
      term: '',
      invoiceDetails: null,
      transactionId: '',
    });
    setEnteredAmounts({});
    setErrors({});
    setStkPushSent(false);
    setPaymentComplete(false);
    setStudents([]);
    setPayments([]);
  };

  // Fetch invoice details
  useEffect(() => {
    if (currentStep === 'invoice') {
      const fetchInvoice = async () => {
        setIsLoading(true);
        try {
          const response = await api.get(`/api/student_invoice/${admissionNumber}`);
          const { student, invoice } = response.data;
          setInvoiceId(response.data.invoiceId);
          setFormData((prev) => ({
            ...prev,
            studentName: student.studentName,
            studentClass: student.studentClass,
            feeBalance: student.feeBalance,
            admissionNumber: student.admissionNumber,
            invoiceDetails: invoice,
          }));
        } catch (error) {
          setErrors({ invoice: error.response?.data?.error || 'Failed to fetch invoice' });
          setCurrentStep('search');
        } finally {
          setIsLoading(false);
        }
      };
      fetchInvoice();
    }
  }, [currentStep, admissionNumber]);

  // Fetch payments when navigating to payments step
  useEffect(() => {
    if (currentStep === 'payments') {
      fetchPayments();
    }
    if (currentStep === 'home') {
      fetchPayments();
    }
  }, [currentStep]);

  // Poll payment status
  useEffect(() => {
    if (stkPushSent && transactionIdd) {
      pollPayment();
    }
  }, [stkPushSent, transactionIdd]);

  // Animation variants
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    in: { opacity: 1, y: 0 },
    out: { opacity: 0, y: -20 },
  };

  const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.5,
  };

  
  // Bottom Navigation Component
  const BottomNav = () => (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around py-3"
    >
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setCurrentStep('home')}
        className={`flex flex-col items-center ${currentStep === 'home' ? 'text-blue-500' : 'text-gray-600'}`}
      >
        <Home className="w-6 h-6" />
        <span className="text-xs">Home</span>
      </motion.button>
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setCurrentStep('payments')}
        className={`flex flex-col items-center ${currentStep === 'payments' ? 'text-blue-500' : 'text-gray-600'}`}
      >
        <List className="w-6 h-6" />
        <span className="text-xs">Payments</span>
      </motion.button>
    {/*  <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setIsPasswordModalOpen(true)}
        className="flex flex-col items-center text-gray-600"
      >
        <Key className="w-6 h-6" />
        <span className="text-xs">Password</span>
      </motion.button>*/}
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={handleSignOut}
        className="flex flex-col items-center text-gray-600"
      >
        <LogOut className="w-6 h-6" />
        <span className="text-xs">Sign Out</span>
      </motion.button>
    </motion.div>
  );

  // Password Modal
  const PasswordModal = () => (
    <Dialog open={isPasswordModalOpen} onClose={() => setIsPasswordModalOpen(false)} className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
          className="bg-white rounded-xl p-6 w-full max-w-md mx-4"
        >
          <Dialog.Title className="text-lg font-bold text-gray-900 mb-4">Change Password</Dialog.Title>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Old Password</label>
              <input
                type="password"
                value={passwordData.oldPassword}
                onChange={(e) => setPasswordData({ ...passwordData, oldPassword: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                placeholder="Enter old password"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">New Password</label>
              <input
                type="password"
                value={passwordData.newPassword}
                onChange={(e) => setPasswordData({ ...passwordData, newPassword: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                placeholder="Enter new password"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Confirm New Password</label>
              <input
                type="password"
                value={passwordData.confirmPassword}
                onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                placeholder="Confirm new password"
              />
            </div>
            {passwordError && (
              <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
                <AlertCircle className="w-4 h-4" />
                <span className="text-sm">{passwordError}</span>
              </div>
            )}
            <div className="flex space-x-4">
              <button
                onClick={handlePasswordChange}
                disabled={isLoading}
                className="flex-1 bg-blue-500 text-white py-3 rounded-xl font-semibold hover:bg-blue-600 flex items-center justify-center space-x-2"
              >
                {isLoading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Key className="w-5 h-5" />}
                <span>Save</span>
              </button>
              <button
                onClick={() => setIsPasswordModalOpen(false)}
                className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-300"
              >
                Cancel
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </Dialog>
  );

  // Home Step (Student List)
  if (currentStep === 'home') {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
        className="w-full max-w-md mx-auto bg-white min-h-screen flex flex-col"
      >
        <div className="flex-1 px-6 py-8">
          <div className="text-center mb-8">
            <img src="https://joharischool.co.ke/wp-content/uploads/2022/01/download.png" className="mx-auto w-24 h-20 rounded" alt="Johari School Logo" />
            <h1 className="text-xl font-bold text-gray-900 mt-4">Welcome, {formData.parentName}</h1>
          </div>
          <div className="bg-blue-50 p-4 rounded-xl mb-6">
            <h2 className="text-lg font-semibold text-blue-800 mb-4">Your Students</h2>
            {isLoading ? (
              <Loader2 className="w-8 h-8 animate-spin mx-auto text-blue-500" />
            ) : students.length > 0 ? (
              <div className="space-y-4">
                {students.map((student) => (
                  <motion.div
                    key={student.admission_number}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    className="bg-white p-4 rounded-xl shadow cursor-pointer"
                    onClick={() => handleStudentSearch(student.admission_number)}
                  >
                    <p className="font-semibold text-gray-900">{student.firstname} {student.lastname} {student.surname}</p>
                    <p className="text-sm text-gray-600">Admission: {student.admission_number}</p>
                    <p className="text-sm text-gray-600">Class: {student.class_admitted_to}</p>
                  <br/>
                    <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => handleStudentSearch(student.admission_number)}
            className="w-full bg-blue-500 text-white py-3 rounded-xl font-semibold flex items-center justify-center space-x-2"
          >
            <Search className="w-5 h-5" />
            <span>View & Pay Fee Balance</span>
          </motion.button>
                  </motion.div>
                ))}
              </div>
            ) : (
              <p className="text-gray-600 text-center">No students found.</p>
            )}
            {errors.students && (
              <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
                <AlertCircle className="w-4 h-4" />
                <span className="text-sm">{errors.students}</span>
              </div>
            )}
          </div>
         {/* <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => setCurrentStep('search')}
            className="w-full bg-blue-500 text-white py-3 rounded-xl font-semibold flex items-center justify-center space-x-2"
          >
            <Search className="w-5 h-5" />
            <span>Search Another Student</span>
          </motion.button>*/}
        </div>
        <BottomNav />
      </motion.div>
    );
  }

  // Login Step
  if (currentStep === 'login') {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
        className="w-full max-w-md mx-auto bg-white min-h-screen flex flex-col justify-center"
      >
        <div className="px-6 py-8">
          <div className="text-center mb-8">
            <img src="https://joharischool.co.ke/wp-content/uploads/2022/01/download.png" className="mx-auto w-24 h-20 rounded" alt="Johari School Logo" />
            <h1 className="text-xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent mt-4">Parent Portal</h1>
            <div className="w-16 h-1 bg-[#ff7713] rounded-full mx-auto mt-2"></div>
            <p className="text-gray-600">Login to pay school fees</p>
          </div>
          <div className="space-y-6">
            <div>
  <label className="block text-sm font-semibold text-gray-700 mb-2 flex justify-between items-center">
    <span>Parent Phone</span>
  {/*  <button
     onClick={() => handleOtp()}
      type="button"
      className="bg-blue-500 text-white text-xs font-semibold px-3 py-1 rounded-lg hover:bg-blue-600 focus:ring-2 focus:ring-blue-300 transition"
    >
      Send OTP
    </button>*/}
  </label>

  <input
    type="tel"
    value={formData.parentPhone}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, "").slice(0, 10);
      setFormData({ ...formData, parentPhone: value });
    }}
    minLength={10}
    maxLength={10}
    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
    placeholder="0712345678"
  />
</div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Enter Password</label>
              <input
                type="password"
                value={formData.parentName}
                onChange={(e) => setFormData({ ...formData, parentName: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                placeholder="Password"
              />
            </div>
            {errors.login && (
              <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
                <AlertCircle className="w-4 h-4" />
                <span className="text-sm">{errors.login}</span>
              </div>
            )}
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={handleLogin}
              disabled={isLoading}
              style={{ backgroundColor: 'rgb(2, 3, 129)' }}
              className="w-full text-white py-3 rounded-xl font-semibold flex items-center justify-center space-x-2"
            >
              {isLoading ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  <span>Please wait...</span>
                </>
              ) : (
                <>
                  <Lock className="w-5 h-5" />
                  <span>Sign In</span>
                </>
              )}
            </motion.button>
          </div>
        </div>
      </motion.div>
    );
  }

  // Search Step
  if (currentStep === 'search') {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
        className="w-full max-w-md mx-auto bg-white min-h-screen flex flex-col"
      >
        <div className="flex-1 px-6 py-8">
          <div className="flex items-center mb-6">
            <button onClick={() => setCurrentStep('home')} className="mr-4">
              <ArrowLeft className="w-6 h-6 text-gray-600" />
            </button>
            <h1 className="text-xl font-bold text-gray-900">Find Student</h1>
          </div>
          <div className="bg-blue-50 p-4 rounded-xl mb-6">
            <p className="text-blue-800">Welcome, {formData.parentName}!</p>
          </div>
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Student Admission Number</label>
              <div className="relative">
                <Search className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                <input
                  type="text"
                  value={formData.admissionNumber}
                  onChange={(e) => setFormData({ ...formData, admissionNumber: e.target.value })}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                  placeholder="e.g., 101"
                />
              </div>
            </div>
            {errors.search && (
              <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
                <AlertCircle className="w-4 h-4" />
                <span className="text-sm">{errors.search}</span>
              </div>
            )}
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={handleStudentSearch}
              disabled={isLoading}
              className="w-full bg-blue-500 text-white py-3 rounded-xl font-semibold flex items-center justify-center space-x-2"
            >
              {isLoading ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  <span>Searching...</span>
                </>
              ) : (
                <>
                  <Search className="w-5 h-5" />
                  <span>Search Student</span>
                </>
              )}
            </motion.button>
          </div>
        </div>
        <BottomNav />
      </motion.div>
    );
  }

  // Payments Step
  if (currentStep === 'payments') {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
        className="w-full max-w-md mx-auto bg-white min-h-screen flex flex-col"
      >
        <div className="flex-1 px-6 py-8">
          <div className="flex items-center mb-6">
            <button onClick={() => setCurrentStep('home')} className="mr-4">
              <ArrowLeft className="w-6 h-6 text-gray-600" />
            </button>
            <h1 className="text-xl font-bold text-gray-900">Payment History</h1>
          </div>
          {isLoading ? (
            <Loader2 className="w-8 h-8 animate-spin mx-auto text-blue-500" />
          ) : payments.length > 0 ? (
            <div className="space-y-4">
              {payments.map((payment) => (
                <motion.div
                  key={payment.payment_reference}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="bg-gray-50 p-4 rounded-xl cursor-pointer"
                  onClick={() => downloadReceipt(payment.id)}
                >
                  <p className="font-semibold text-gray-900">KSh {parseFloat(payment.amount).toLocaleString()}</p>
                  <p className="text-sm text-gray-600">Mpesa No: {payment.contact}</p>
                  <p className="text-sm text-gray-600">Date: {new Date(payment.created_at).toLocaleDateString()}</p>
                  
                  <p className="text-sm text-gray-600">Transaction ID: {payment.payment_reference}</p>
                <br/>
                 <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => downloadReceipt(payment.id)}
            className="w-full bg-blue-500 text-white py-3 rounded-xl font-semibold flex items-center justify-center space-x-2"
          >
            <Download className="w-5 h-5" />
            <span>Download Receipt</span>
          </motion.button>
                </motion.div>
              ))}
            </div>
          ) : (
            <p className="text-gray-600 text-center">No payment history found.</p>
          )}
          {errors.payments && (
            <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
              <AlertCircle className="w-4 h-4" />
              <span className="text-sm">{errors.payments}</span>
            </div>
          )}
        </div>
        <BottomNav />
      </motion.div>
    );
  }

  // Invoice Step
 if (currentStep === 'invoice') {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
        className="w-full max-w-md mx-auto bg-white min-h-screen flex flex-col"
      >
        <div className="flex-1 px-6 py-8">
          <div className="flex items-center mb-6">
            <button onClick={() => setCurrentStep('home')} className="mr-4">
              <ArrowLeft className="w-6 h-6 text-gray-600" />
            </button>
            <h1 className="text-xl font-bold text-gray-900">Fee Invoice</h1>
          </div>
          {isLoading ? (
            <div className="text-center">
              <Loader2 className="w-8 h-8 animate-spin mx-auto text-blue-500" />
              <p className="text-gray-600 mt-2">Loading invoice...</p>
            </div>
          ) : (
            <>
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                className="bg-gradient-to-r from-purple-500 to-purple-600 text-white p-6 rounded-xl mb-6"
              >
                <h2 className="text-xl font-bold mb-2">{formData.studentName}</h2>
                <p className="opacity-90">Class: {formData.studentClass}</p>
                <p className="opacity-90">Admission: {formData.admissionNumber}</p>
              </motion.div>
              <AnimatePresence mode="wait">
               
                  <motion.div
                    key="invoice-details"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 0.4 }}
                    className="bg-gray-50 p-6 rounded-xl mb-6"
                  >
                    <h3 className="text-lg font-semibold text-gray-900 mb-4">Invoice Details</h3>
                    <div className="space-y-3">
                      {Object.entries(formData.invoiceDetails).map(([itemName, items]) => (
                        <div key={itemName}>
                          <h4 className="font-bold text-gray-700 mb-1">{itemName}</h4>
                          {Object.entries(items).map(([itemId, price]) => (
                            <div key={itemId} className="flex justify-between text-sm">
                              <span className={price > 0 ? "text-red-600" : "text-green-600"}>
                                Pending Balance
                              </span>
                              <span className={`font-semibold ${price > 0 ? "text-red-600" : "text-green-600"}`}>
                                KSh {parseFloat(price).toLocaleString()}
                              </span>
                            </div>
                          ))}
                        </div>
                      ))}
                      <hr className="my-3" />
                      <div
                        className={`flex justify-between text-md font-bold ${
                          formData.feeBalance > 0 ? "text-red-600" : "text-green-600"
                        }`}
                      >
                        <span>Total Outstanding</span>
                        <span>KSh {parseFloat(formData.feeBalance).toLocaleString()}</span>
                      </div>
                    </div>
                  </motion.div>
               
                {formData.feeBalance >= 1 && formData.invoiceDetails ? (
                <div></div>
                ) : (
                  formData.feeBalance < 1 && (
                    <motion.div
                      key="success-alert"
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 20 }}
                      transition={{ duration: 0.4 }}
                      className="bg-gray-50 p-6 rounded-xl mb-6 text-green-800 text-center"
                    >
                      <span className="text-lg font-semibold">✅ All Fee Has Been Paid Successfully!</span>
                    </motion.div>
                  )
                )}
              </AnimatePresence>
              {errors.invoice && (
                <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
                  <AlertCircle className="w-4 h-4" />
                  <span className="text-sm">{errors.invoice}</span>
                </div>
              )}
              {formData.feeBalance >= 1 && (
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => setCurrentStep('payment')}
                  className="w-full bg-green-500 text-white py-3 rounded-xl font-semibold flex items-center justify-center space-x-2"
                >
                  <CreditCard className="w-5 h-5" />
                  <span>Pay with M-Pesa</span>
                </motion.button>
              )}
            </>
          )}
        </div>
        <BottomNav />
      </motion.div>
    );
}

  // Payment Step
  if (currentStep === 'payment') {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
        className="w-full max-w-md mx-auto bg-white min-h-screen flex flex-col"
      >
        <div className="flex-1 px-6 py-8">
          <div className="flex items-center mb-6">
            <button onClick={() => setCurrentStep('invoice')} className="mr-4">
              <ArrowLeft className="w-6 h-6 text-gray-600" />
            </button>
            <h1 className="text-xl font-bold text-gray-900">M-Pesa Payment</h1>
          </div>
          <div className="bg-blue-50 p-4 rounded-xl mb-6">
            <p className="font-semibold text-blue-900">{formData.studentName}</p>
            <p className="text-blue-700 text-sm">Outstanding: KSh {parseFloat(formData.feeBalance).toLocaleString()}</p>
          </div>
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">M-Pesa Phone Number</label>
              <div className="relative">
                <Phone className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                <input
                  type="tel"
                  value={formData.phoneNumber}
                  onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500"
                  placeholder="0712345678"
                />
              </div>
            </div>
           

 {formData.invoiceDetails && (
  <div className="space-y-3">
    {Object.entries(formData.invoiceDetails).map(([itemName, items]) => (
      <div key={itemName}>
      
        {Object.entries(items).map(([itemId, price]) =>
          price > 0 ? (

            <div key={itemId}>
              <h3 className="font-bold text-lg mb-2">{itemName}</h3>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Amount KSh {price}
              </label>
              <input
                type="number"
                value={enteredAmounts[itemId] || ''} // store using itemId
                onChange={(e) =>{
                  setEnteredAmounts({
                    ...enteredAmounts,
                    [itemId]: e.target.value, // store separately per itemId
                  });
                  setTotalAmount();
                }
                }
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500"
                placeholder="Enter amount"
                min="1"
              />
            </div>
          ) : null
        )}
      </div>
    ))}
  </div>
)}



               
            {errors.payment && (
              <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
                <AlertCircle className="w-4 h-4" />
                <span className="text-sm">{errors.payment}</span>
              </div>
            )}
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={handlePayment}
              disabled={isLoading}
              className="w-full bg-green-500 text-white py-3 rounded-xl font-semibold flex items-center justify-center space-x-2"
            >
              {isLoading ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  <span>Processing...</span>
                </>
              ) : (
                <>
                  <Phone className="w-5 h-5" />
                  <span>Send STK Push</span>
                </>
              )}
            </motion.button>
          </div>
        </div>
        <BottomNav />
      </motion.div>
    );
  }

  // STK Push Step
  if (currentStep === 'stk-push') {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
        className="w-full max-w-md mx-auto bg-white min-h-screen flex flex-col"
      >
        <div className="flex-1 px-6 py-8 text-center">
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="w-24 h-24 mx-auto mb-6"
          >
            {!paymentComplete ? (
              <div className="w-24 h-24 border-4 border-green-200 border-t-green-500 rounded-full animate-spin"></div>
            ) : (
              <div className="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center">
                <Check className="w-12 h-12 text-white" />
              </div>
            )}
          </motion.div>
          {!paymentComplete ? (
            <>
              <h2 className="text-xl font-bold text-gray-900 mb-4">STK Push Sent!</h2>
              <p className="text-gray-600 mb-6">Please check your phone and enter your M-Pesa PIN to complete the payment.</p>
              <div className="bg-green-50 p-4 rounded-xl">
                <p className="text-green-800 font-semibold">Amount: KSh {parseFloat(total__amount).toLocaleString()}</p>
                <p className="text-green-700">Phone: {formData.phoneNumber}</p>
              </div>
            </>
          ) : (
            <>
              <h2 className="text-xl font-bold text-green-600 mb-4">STK Push Sent!</h2>
              <p className="text-gray-600 mb-6">Please check your phone and enter your M-Pesa PIN to complete the payment.</p>
              
            </>
          )}
        </div>
        <BottomNav />
      </motion.div>
    );
  }

  // Receipt Step
  if (currentStep === 'receipt') {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
        className="w-full max-w-md mx-auto bg-white min-h-screen flex flex-col"
      >
        <div className="flex-1 px-6 py-8">
          <div className="text-center mb-8">
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4"
            >
              <Check className="w-8 h-8 text-white" />
            </motion.div>
            <h1 className="text-2xl font-bold text-green-600 mb-2">Payment Successful!</h1>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-gray-50 p-6 rounded-xl mb-6"
          >
            <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">Payment Receipt</h3>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Transaction ID</span>
                <span className="font-mono font-semibold">{formData.transactionId}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Date</span>
                <span className="font-semibold">{new Date().toLocaleDateString()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Time</span>
                <span className="font-semibold">{new Date().toLocaleTimeString()}</span>
              </div>
              <hr className="my-3" />
              <div className="flex justify-between">
                <span className="text-gray-600">Student Name</span>
                <span className="font-semibold">{formData.studentName}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Admission No.</span>
                <span className="font-semibold">{formData.admissionNumber}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Class</span>
                <span className="font-semibold">{formData.studentClass}</span>
              </div>
              <hr className="my-3" />
              <div className="flex justify-between">
                <span className="text-gray-600">Payment Method</span>
                <span className="font-semibold">M-Pesa</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Phone Number</span>
                <span className="font-semibold">{formData.phoneNumber}</span>
              </div>
              <div className="flex justify-between text-lg font-bold text-green-600">
                <span>Amount Paid</span>
                <span>KSh {parseFloat(formData.amount).toLocaleString()}</span>
              </div>
            </div>
          </motion.div>
          {errors.receipt && (
            <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
              <AlertCircle className="w-4 h-4" />
              <span className="text-sm">{errors.receipt}</span>
            </div>
          )}
          <div className="space-y-4">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => downloadReceipt(formData.transactionId)}
              className="w-full bg-blue-500 text-white py-3 rounded-xl font-semibold flex items-center justify-center space-x-2"
            >
              <Download className="w-5 h-5" />
              <span>Download Receipt</span>
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => setCurrentStep('search')}
              className="w-full bg-gray-100 text-gray-700 py-3 rounded-xl font-semibold"
            >
              Make Another Payment
            </motion.button>
          </div>
        </div>
        <BottomNav />
      </motion.div>
    );
  }


  return (
    <AnimatePresence>
      <PasswordModal />
    </AnimatePresence>
  );
};

export default ParentFeePayment;